import React from "react";

const OPTIONS = [
  { value: "beginner", label: "Beginner", icon: "ti-seedling" },
  { value: "moderate", label: "Intermediate", icon: "ti-chart-line" },
  { value: "advanced", label: "Advanced", icon: "ti-rocket" },
];

export default function LevelSelectionCards({ title, value = "beginner", onChange }) {
  return (
    <section style={{ margin: "0 0 12px", padding: 12, border: "1px solid #D8E2EA", borderRadius: 10, background: "#F8FAFC" }}>
      <strong style={{ display: "block", marginBottom: 8, color: "#143B56", fontSize: 12.5 }}>{title}</strong>
      <div role="radiogroup" aria-label={title} style={{ display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: 8 }}>
        {OPTIONS.map((option) => {
          const selected = value === option.value;
          return (
            <button key={option.value} type="button" role="radio" aria-checked={selected} onClick={() => onChange?.(option.value)} style={{ minHeight: 52, display: "flex", justifyContent: "center", alignItems: "center", gap: 7, padding: "9px 8px", border: `1.5px solid ${selected ? "#0F766E" : "#D8E2EA"}`, borderRadius: 8, background: selected ? "#E7F7F3" : "#fff", color: selected ? "#0F766E" : "#334155", fontSize: 12, fontWeight: selected ? 750 : 650, cursor: "pointer" }}>
              <i className={`ti ${option.icon}`} aria-hidden="true" style={{ fontSize: 16 }} />{option.label}
            </button>
          );
        })}
      </div>
    </section>
  );
}
